import { render, staticRenderFns } from "./OrdersNeedsFinalizing.vue?vue&type=template&id=1b4589c4&scoped=true&"
import script from "./OrdersNeedsFinalizing.vue?vue&type=script&lang=js&"
export * from "./OrdersNeedsFinalizing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4589c4",
  null
  
)

export default component.exports